
import { Component, HostListener, NgZone, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { HomeCategories } from 'src/app/interfaces/homecategories.inteface';
import { WpapiService } from 'src/app/services/wpapi.service';

@Component({
    selector: 'app-home-categories',
    templateUrl: './home-categories.component.html',
    styleUrls: ['./home-categories.component.scss'],
})
export class HomeCategoriesComponent implements OnInit {
    homecategories: any;
    requestId;
    width: number = 0;
    activeCategory: number;
    lastActiveCategory: number;
    interval;
    isNotPaused: boolean = false;
    data$: Observable<any>;
    myData: HomeCategories;
    labelwidth: number = 0;
    screenWidth: number = 0;
    animate: boolean = false;
    categories: any;

    constructor(private wpApi: WpapiService) {
        this.onResize();
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.screenWidth = window.innerWidth;
    }
    ngOnInit() {
        this.wpApi.homeCategories().subscribe(resp => {
            this.homecategories = resp;
            if (this.screenWidth > 1024) {
                this.labelwidth = 150 / this.homecategories.length;
            } else {
                this.labelwidth = 150 / this.homecategories.length;
            }
        });
        this.interval = setInterval(() => {
            if (this.isNotPaused) {
                if (this.width >= 100) {
                    this.width = 0;
                    this.callBackSlide();
                } else {
                    this.width++;
                }
            }
        }, 200);
    }

    loadedImage(i) {
        document.getElementById('home-categories-image-' + i).classList.add('loaded')
    }

    public onIntersection({ target, visible }: { target: Element; visible: boolean }): void {
        if (visible) {
            if (!this.categories) {
                this.categories = this.homecategories;
                setTimeout(() => {
                    this.activeCategory = 0;
                    this.animate = true;
                }, 200);
                setTimeout(() => {
                    this.lastActiveCategory = 0;
                }, 500);
            }

            this.isNotPaused = true;
        } else {
            this.isNotPaused = false;
        }
    }

    callBackSlide() {
        this.activeCategory++;
        if (this.activeCategory >= this.homecategories.length) {
            this.activeCategory = 0;
        }
        setTimeout(() => {
            this.lastActiveCategory++;
            if (this.lastActiveCategory >= this.homecategories.length) {
                this.lastActiveCategory = 0;
            }
        }, 700);
    }

    activeSlide(i) {
        this.width = 0;
        this.activeCategory = i;
        if (this.activeCategory >= this.homecategories.length) {
            this.activeCategory = 0;
        }
        if (this.activeCategory < 0) {
            this.activeCategory = this.homecategories.length - 1;
        }
        setTimeout(() => {
            this.lastActiveCategory = i;
            if (this.lastActiveCategory >= this.homecategories.length) {
                this.lastActiveCategory = 0;
            }
            if (this.lastActiveCategory < 0) {
                this.lastActiveCategory = this.homecategories.length - 1;
            }
        }, 700);
    }

    onSwipeLeft() {
        if (this.screenWidth <= 1024) {
            var nextSlide = this.activeCategory + 1;
            this.activeSlide(nextSlide);
        }
    }

    onSwipeRight() {
        if (this.screenWidth <= 1024) {
            var prevSlide = this.activeCategory - 1;
            this.activeSlide(prevSlide);
        }
    }
}
